import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-neutral-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12">
        <div className="grid gap-16 sm:grid-cols-2 lg:grid-cols-5">
          <div>
            <p className="font-display text-2xl font-extrabold tracking-tight">DISJINX<span className="text-neutral-500">.</span></p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-neutral-500">
              AI automation for businesses. We build workflows that take repetitive, time-consuming tasks off your plate.
            </p>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-neutral-500">Explore</p>
            <div className="mt-5 flex flex-col gap-3">
              <Link to="/" data-testid="footer-link-overview" className="w-fit text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950">Overview</Link>
              <Link to="/faq" data-testid="footer-link-faq" className="w-fit text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950">FAQ</Link>
              <Link to="/contact" data-testid="footer-link-contact" className="w-fit text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950">Contact</Link>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-neutral-500">Legal</p>
            <div className="mt-5 flex flex-col gap-3">
              <Link to="/privacy" data-testid="footer-link-privacy" className="w-fit text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950">Privacy Policy</Link>
              <Link to="/terms" data-testid="footer-link-terms" className="w-fit text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950">Terms and Conditions</Link>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-neutral-500">Socials</p>
            <div className="mt-5 flex flex-col gap-3">
              <a
                href="https://instagram.com/disjinx_au"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="DISJINX on Instagram (@disjinx_au)"
                data-testid="footer-link-instagram"
                className="group inline-flex w-fit items-center gap-2 text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950"
              >
                <Instagram className="h-4 w-4 transition-transform duration-200 group-hover:-translate-y-0.5" strokeWidth={1.75} />
                Instagram
                <ArrowUpRight className="h-3.5 w-3.5 text-neutral-500 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-neutral-500">Talk to us</p>
            <div className="mt-5 flex flex-col gap-3">
              <a href="mailto:disjinx.support@gmail.com" data-testid="footer-email-support" className="group inline-flex w-fit items-center gap-1 text-sm font-medium text-neutral-700 transition-colors duration-200 hover:text-neutral-950">
                disjinx.support@gmail.com
                <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-20 flex flex-col gap-2 border-t border-neutral-200 pt-8 text-xs text-neutral-500 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} DISJINX. All rights reserved.</p>
          <p>Automate the busywork. Reclaim the day.</p>
        </div>
      </div>
    </footer>
  );
}
